define.alias("shared/components/shared/media-item-droppable", "auth/components/shared/media-item-droppable");